import { render } from "./UserRegisterBase.vue?vue&type=template&id=7c24f662&scoped=true"
import script from "./UserRegisterBase.vue?vue&type=script&lang=js"
export * from "./UserRegisterBase.vue?vue&type=script&lang=js"

import "./UserRegisterBase.vue?vue&type=style&index=0&id=7c24f662&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c24f662"]])

export default __exports__